import React from 'react';

import UppyUploader from '@components/common/uppy/main';
import './styles/main.scss';

class CsvUpload extends React.Component {
  triggerUpload = (files) => {
    this.uploadCSV(files[0].url);
  }

  uploadCSV = (url) => {
    fetch(`/${BF.fx.resource().slug}/assets/csv/upload_assets`, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${BF_Token}`
      },
      body: JSON.stringify({
        csv_url: url,
        resource_key: BF.fx.brandfolder().key
      })
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Upload failed for: ${BF.fx.brandfolder().slug}`);
        }
        return response;
      });
  };

  trigger = () => 'uppy-csv-upload-trigger';

  renderArea() {
    return (
      <div id={this.trigger()} className="uppy-csv-area">
        <span className="bff-plus" />
        <p>{t("Click to upload a CSV")}</p>
      </div>
    );
  }

  render() {
    return (
      <React.Fragment>
        {this.renderArea()}
        <UppyUploader
          {...this.props}
          template="file_ingest"
          handleUpload={this.triggerUpload}
          uniqIdentifier={`csv-uppy-${BF.fx.brandfolder().key}`}
          restrictions={{
            // 358kb: a csv with roughly 10k rows
            maxFileSize: 358000,
            maxNumberOfFiles: 1,
            allowedFileTypes: ['.csv']
          }}
          button
          trigger={`#${this.trigger()}`}
        />
      </React.Fragment>
    );
  }
}

export default CsvUpload;
